import { Component, OnInit } from '@angular/core';
import {PartnerSummaryModel} from '../../../api/model/partnerSummary.model';
import {IDialogComponent} from '../../../../../common/dialog/iDialog.component';
import {DialogWithInput} from '../../../../../common/dialog/dialogWithInput';
import {PartnerGetSimilarPartnersActionService} from '../../../api/service/partnerGetSimilarPartnersAction.service';
import {BaseView} from '../../../../../core/view/base.view';
import {PartnerCommandService} from "../../../api/command/partnerCommand.service";
import {LovValueSummary} from "../../../../../common/lov/lov-value/api/model/lovValueSummary.model";
import {DialogController} from "../../../../../common/dialog/dialogController";
import {PartnerMergeDialogInput} from "../../../api/component/partner-merge-dialog/partner-merge-dialog.component";
import {PartnerRemoveSimilarService} from "../../../api/service/similar/partnerRemoveSimilar.service";

export interface PartnerSimilarPartnerViewDialogInput {
  partnerSummary: PartnerSummaryModel;
}

@Component({
  selector: 'app-partner-similar-partner-view-dialog',
  templateUrl: './partner-similar-partner-view-dialog.component.html',
  providers: [
    PartnerGetSimilarPartnersActionService,
    PartnerCommandService,
    PartnerRemoveSimilarService,
  ],
})
export class PartnerSimilarPartnerViewDialogComponent extends BaseView
    implements IDialogComponent<PartnerSimilarPartnerViewDialogInput, void>, OnInit {

  result: PartnerSimilarPartner[] = [];
  dialog: DialogWithInput<PartnerSimilarPartnerViewDialogInput, void>;
  constructor(public service: PartnerGetSimilarPartnersActionService,
              public partnerCommandService: PartnerCommandService,
              private dialogController: DialogController,
              public removeSimilarService: PartnerRemoveSimilarService) {
    super();
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.result = [];
    this.service.executeAction({
      id: this.dialog.input.partnerSummary.id
    }).then((result) => {
      result.partners.forEach((partner) => {
        let resultItem = this.result.find((p) => p.partner.id === partner.partner.id);
        if (!resultItem) {
          resultItem = new PartnerSimilarPartner();
          resultItem.partner = partner.partner;
          this.result.push(resultItem);
        }
        resultItem.reasons.push(partner.reason);
      });
    });
  }

  async merge(partner: PartnerSummaryModel) {

    const { PartnerMergeDialogComponent} = await import(
        '../../../api/component/partner-merge-dialog/partner-merge-dialog.component'
        );
    const input: any = {
      partnerToKeep: this.dialog.input.partnerSummary,
      partnerToDelete: partner,
      typeValue: this.dialog.input.partnerSummary.mainType.type.value
    }

    this.dialogController.open(PartnerMergeDialogComponent, input, {
      title: 'Fusionner',
      width: '95%'
    }).afterClosed()
        .toPromise();
    this.dialog.close();
  }

  removeSimilar(partnerId: number) {
    this.removeSimilarService.executeAction({
      partnerId1: partnerId,
      partnerId2: this.dialog.input.partnerSummary.id
    }).then(() => {
      this.refresh();
    }).catch((e) => this.toastControl.presentError(e))
  }

}

export class PartnerSimilarPartner {
    partner: PartnerSummaryModel;
    reasons: LovValueSummary[] = [];
}
